(function () {
    angular.module('PWAPoCApp').controller('attachmentPictureModalController', AttachmentPictureModalController);

    AttachmentPictureModalController.$inject = ['$scope', 'imageBase64', '$windowInstance'];

function AttachmentPictureModalController($scope, imageBase64, $windowInstance) {
    $scope.imageBase64 = imageBase64;

    $scope.close = function () {
        $windowInstance.close();
    };
}
})();
